"use client"

import type { FunctionComponent } from "react"

import Skeleton from "react-loading-skeleton"

import styles from "./RegistrationDetails.module.css"

export const RegistrationDetailsPlaceholder: FunctionComponent = () => {
  return (
    <Skeleton
      containerClassName={styles.registrationDetailsPlaceholder}
      containerTestId="registration-details-placeholder"
      height="120px"
    />
  )
}
